import { format, isToday, isYesterday } from 'date-fns'
import { id } from 'date-fns/locale'

// by providing a default string of 'PP' or any of its variants for `formatStr`
// it will format dates in whichever way is appropriate to the locale
const formatDate = (dt: string | number | Date, fmt: string = 'PP') => {
  return format(dt, fmt, { locale: id })
}
export default {
  /**
   * Format date with given string format. Set locale to id
   * See https://date-fns.org/docs/format for accepted tokens
   */
  date: formatDate,

  dateLong: (dt: string | number | Date) => {
    return formatDate(dt, 'cccc, dd MMMM yyyy HH:mm')
  },

  /**
   * Shorter format date. If date is today, it will only show time,
   * otherwise show the date.
   */
  dateShort: (dt: string | number | Date) => {
    if (isToday(dt)) {
      return formatDate(dt, 'HH:mm')
    }
    if (isYesterday(dt)) {
      return 'Kemarin'
    }

    return formatDate(dt)
  },

  formToday: () => formatDate(new Date(), 'yyyy-MM-dd'),
}
